export default __webpack_public_path__ + "static/media/google.dd089960.svg";